import {vec2, vec3, vec4} from 'gl-matrix';
import * as Stats from 'stats-js';
import * as DAT from 'dat-gui';
import Square from './geometry/Square';
import Plane from './geometry/Plane';
import ScreenQuad from './geometry/ScreenQuad'
import OpenGLRenderer from './rendering/gl/OpenGLRenderer';
import Camera from './Camera';
import {setGL} from './globals';
import ShaderProgram, {Shader} from './rendering/gl/ShaderProgram';
import {readTextFile} from './globals';
import {loadTexture} from './Texture';

// Define an object with application parameters and button callbacks
// This will be referred to by dat.GUI's functions that add GUI elements.
const controls = {
};

let screenQuad: ScreenQuad;
let paper: Plane; 
let square: Square;
let time: number = 0;
let prevColor: string;

function loadScene() {
  // square = new Square(vec3.fromValues(0, 0, 0));
  // square.create();
  screenQuad = new ScreenQuad();
  screenQuad.create();
  paper = new Plane(vec3.fromValues(0,0,-0.31), vec2.fromValues(1.3, 1.3), 10);
  paper.create();
  time = 0;
}

function hexToRgb(hex: string) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
  } : null;
}

function main() {
  window.addEventListener('keypress', function (e) {
    // console.log(e.key);
    switch(e.key) {
      // Use this if you wish
    }
  }, false);

  window.addEventListener('keyup', function (e) {
    switch(e.key) {
      // Use this if you wish
    }
  }, false);

  // Initial display for framerate
  const stats = Stats();
  stats.setMode(0);
  stats.domElement.style.position = 'absolute';
  stats.domElement.style.left = '0px';
  stats.domElement.style.top = '0px';
  document.body.appendChild(stats.domElement);

  // Add controls to the gui
  const gui = new DAT.GUI();

  // get canvas and webgl context
  const canvas = <HTMLCanvasElement> document.getElementById('canvas');
  const gl = <WebGL2RenderingContext> canvas.getContext('webgl2');
  if (!gl) {
    alert('WebGL 2 not supported!');
  }
  // `setGL` is a function imported above which sets the value of `gl` in the `globals.ts` module.
  // Later, we can import `gl` from `globals.ts` to access it
  setGL(gl);

  // Initial call to load scene
  loadScene();
  // prevColor = "#ff0000";
  // var rgbColor = hexToRgb(prevColor);

  const camera = new Camera(vec3.fromValues(-0.4, 1.522, -2.09), vec3.fromValues(0, 0, 0));
  camera.controls.up = vec4.fromValues(0.11, -0.808, -0.612, 0.0);
  camera.controls.tick();

  const renderer = new OpenGLRenderer(canvas);
  renderer.setClearColor(185.0 / 255.0, 187.0 / 255.0, 181.0 / 255.0, 1);
  gl.enable(gl.DEPTH_TEST);

  const flat = new ShaderProgram([
    new Shader(gl.VERTEX_SHADER, require('./shaders/flat-vert.glsl')),
    new Shader(gl.FRAGMENT_SHADER, require('./shaders/flat-frag.glsl')),
  ]);
  flat.setGeometryColor(vec4.fromValues(107.0 / 255, 107.0 / 255, 107.0 / 255, 1));

 // const env = new ShaderProgram([
 //   new Shader(gl.VERTEX_SHADER, require('./shaders/env-vert.glsl')),
 //   new Shader(gl.FRAGMENT_SHADER, require('./shaders/env-frag.glsl')),
 // ]);

  const env2 = new ShaderProgram([
    new Shader(gl.VERTEX_SHADER, require('./shaders/env2-vert.glsl')),
    new Shader(gl.FRAGMENT_SHADER, require('./shaders/env2-frag.glsl')),
  ]);

  const texture = loadTexture(gl, './src/resources/texture.jpg');

  const renderTexture = gl.createTexture();
  gl.bindTexture(gl.TEXTURE_2D, renderTexture);
  gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA,
                512, 512, 0,
                gl.RGBA, gl.UNSIGNED_BYTE, null);
  // set the filtering so we don't need mips
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
  gl.bindTexture(gl.TEXTURE_2D, null);

  var fbo = gl.createFramebuffer();
  gl.bindFramebuffer(gl.FRAMEBUFFER, fbo);
  gl.framebufferTexture2D(
    gl.FRAMEBUFFER,
    gl.COLOR_ATTACHMENT0,
    gl.TEXTURE_2D,
    renderTexture,
    0);


  function processKeyPresses() {
    // Use this if you wish
  }

  // This function will be called every frame
  function tick() {
    camera.update();
    stats.begin();
    gl.bindFramebuffer(gl.FRAMEBUFFER, fbo);
    gl.viewport(0, 0, 512, 512);
    renderer.clear();
    processKeyPresses();
    renderer.render(camera, flat, [
      screenQuad,
    ], time);
    gl.flush();
    time += 1.0; //controls.Speed;
    //if(controls.color !== prevColor) {
    //  prevColor = controls.color;
    //  rgbColor = hexToRgb(prevColor);
   //   flat.setGeometryColor(vec4.fromValues(rgbColor.r / 255, rgbColor.g / 255, rgbColor.b / 255, 1));
   // }
    gl.bindFramebuffer(gl.FRAMEBUFFER, null);
    gl.viewport(0, 0, window.innerWidth, window.innerHeight);
    renderer.clear();
    gl.activeTexture(gl.TEXTURE0);
    gl.bindTexture(gl.TEXTURE_2D, renderTexture);
    gl.activeTexture(gl.TEXTURE1);
    gl.bindTexture(gl.TEXTURE_2D, texture);
    renderer.render(camera, env2, [
      screenQuad,
    ], time);
    stats.end();
    // Tell the browser to call `tick` again whenever it renders a new frame
    requestAnimationFrame(tick);
  }

  window.addEventListener('resize', function() {
    renderer.setSize(window.innerWidth, window.innerHeight);
    camera.setAspectRatio(window.innerWidth / window.innerHeight);
    camera.updateProjectionMatrix();
    flat.setDimensions(window.innerWidth, window.innerHeight);
    env2.setDimensions(window.innerWidth, window.innerHeight);
  }, false);

  renderer.setSize(window.innerWidth, window.innerHeight);
  camera.setAspectRatio(window.innerWidth / window.innerHeight);
  camera.updateProjectionMatrix();
  flat.setDimensions(window.innerWidth, window.innerHeight);
  env2.setDimensions(window.innerWidth, window.innerHeight);

  // Start the render loop
  tick();
}

main();



// WEBPACK FOOTER //
// ./src/main.ts